import { PAGE_MODE } from "../../../constants/constants";
import BarButtonFw, {
  BUTTON_DEFAULT,
} from "../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../framework/form/FormFw";
import { MessageUtil } from "../../../util/MessageUtil";
import { BasePage } from "../../../framework/pages/BasePage";
import GridFw, { COLUMN_DEFAULT } from "../../../framework/grid/GridFw";

class OtrosDatosModal extends BasePage {
  renderPage(pageApi) {
    const getForm = () => pageApi.getComponent("form");
    const getForm3 = () => pageApi.getComponent("form3");
    const getGrid12 = () => pageApi.getComponent("grid12");
    const getGridObservaciones = () => pageApi.getComponent("gridObservaciones");
    console.log(pageApi);
    const formConfig3 = {
      layout: "vertical",
      title: "Procedimiento de muestreo utilizado",
      autoLoad: true,
      load: {
        queryId: 354,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 949,
        hideMessage: true,
        hideMessageError: true,
        params: { ID_CADENA: pageApi.getParamId() },
      },
      fields: [
        {
          label: "  ",
          fields: [
            {
              type: "select",
              name: "PLAN_PROCEDIMIENTO",
              label: "Plan / Procedimiento",
              column: 5,
              load: {
                queryId: 910,
                params: { ID_CADENA: pageApi.getParamId() },
              },
              search: true,
            },
          ],
        },
        {
          label: "Datos para emision de Informe",
          fields: [
            { type: "hidden", name: "id_empresa" },
            {
              type: "select",
              name: "id_titular",
              label: "Títular del Informe",
              column: 4,
              load: { queryId: 623 },
              parents: [
                { name: "id_empresa", paramName: "id_empresa", required: true },
              ],
              search: true,
            },
            {
              type: "select",
              name: "id_tipo_informe",
              label: "Tipo de Informe",
              column: 4,
              load: {
                queryId: 565,
                fnOk: (resp) => {
                  if (pageApi.getPageMode() === PAGE_MODE.NEW) {
                    const findOption = resp?.dataList.find(
                      (data) => data.value === 18,
                    );
                    if (findOption) {
                      getForm3().values.id_tipo_informe = findOption.value;
                    }
                  }
                },
              },
            },
          ],
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };

    const fnNew12 = () => {
      getGrid12().addItem({}, true);
    };

    const fnDelete12 = (value, row, index) => {
      getGrid12().deleteItem(row.key);
    };

    const form = {
      layout: "vertical",
      autoLoad: true,
      load: {
        queryId: 354,
        params: {
          ID_CADENA: pageApi.getParamId(),
        },
      },
      title: "",
      collapsible: true,
      fields: [],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };

    const gridBarHeaderButtonconfig12 = {
      fields: [
        {
          ...BUTTON_DEFAULT.NEW,
          label: `Adicionar Inspector`,
          onClick: fnNew12,
        },
      ],
    };

    let array_inspector = [];
    const gridConfig12 = {
      title: "Datos del Inspector responsable del muestreo",
      showIndex: true,
      autoLoad: true,
      pagination: { server: true },
      rowId: "ID_INSPECTOR_CAMPO",
      barHeader: gridBarHeaderButtonconfig12,
      load: {
        queryId: 793,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessageError: true,
      },
      save: {
        queryId: 794,
        hideMessage: true,
        hideMessageError: true,
      },
      dataOptions: {
        out: { includeLabel: true },
      },
      fields: [
        {
          type: "select",
          name: "ID_INSPECTOR",
          label: "Inspector",
          labelName: "NOMBRE_INSPECTOR",
          column: 4,
          search: true,
          allowClear: true,
          editable: true,
          width: 100,
          load: {
            queryId: 913,
            params: {
              id_cadena: pageApi.getParamId(),
            },
            fnOk: (resp) => {
              //console.log(resp.dataList)
              array_inspector = resp.dataList;
            },
          },
          onChange: (value, values, formApi) => {
            let obj = array_inspector.filter((data) => data.value === value);

            obj.forEach((x) => {
              console.log(x.value);
              getGrid12().itemEditing.ID_INSPECTOR = x.value;
              console.log(getGrid12().itemEditing.value);
            });
            getGrid12().refresh();
          },
        },
        {
          ...COLUMN_DEFAULT.DELETE,
          label: "Opciones",
          onClick: fnDelete12,
          confirm: false,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };

    const fnNew5 = () => {
      getGridObservaciones().addItem({}, true);
    };

    const fnDelete5 = (value, row, index) => {
      getGridObservaciones().deleteItem(row.key);
    };

    const gridBarHeaderButtonconfig5 = {
      fields: [
        { ...BUTTON_DEFAULT.NEW, label: `Agregar Item`, onClick: fnNew5 },
      ],
    };

    const gridObservaciones = {
      title: "Observaciones",
      showIndex: true,
      autoLoad: true,
      pagination: { server: true },
      rowId: "ID_OBSERVACION",
      barHeader: gridBarHeaderButtonconfig5,
      scroll: {
        x: "auto",
      },
      load: {
        queryId: 421,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessageError: true,
      },
      save: {
        queryId: 418,
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        {
          type: "select",
          name: "TIPO_OBSERVACION",
          label: "Tipo",
          labelName: "DESCRIPCION",
          editable: true,
          load: { queryId: 422 },
        },
        { name: "OBSERVACION", label: "Observación", editable: true },
        {
          ...COLUMN_DEFAULT.DELETE,
          label: "Opciones",
          onClick: fnDelete5,
          confirm: false,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };

    const barButtonFooterdatos_servicio = {
      fields: [
        {
          ...BUTTON_DEFAULT.RETURN,
          label: "Retornar Inicio",
          onClick: () => {
            this.props.history.push(
              `/solicitudes-asignadas/solicitudes-asignadas/${pageApi.name.id_ss}`,
            );
          },
        },
        {
          ...BUTTON_DEFAULT.SAVE,
          label: "Guardar",
          onClick: () => {
            getForm3().save();
            getGrid12().save({ params: { ID_CADENA: pageApi.getParamId() } });
            getGridObservaciones().save({ params: { ID_CADENA: pageApi.getParamId() } });
            MessageUtil("success", "Se actualizó correctamente");
          },
        },
        {
          ...BUTTON_DEFAULT.NEXT,
          label: "Continuar",
          onClick: () => {
            getForm3().save();
            getGrid12().save({ params: { ID_CADENA: pageApi.getParamId() } });
            getGridObservaciones().save({ params: { ID_CADENA: pageApi.getParamId() } });
            this.props.history.push(
              `/solicitudes-asignadas/solicitudes-asignadas/${getForm3()?.getData()?.ID_SOLICITUD_SERVICIO}`,
            );
            MessageUtil("success", "Se actualizó correctamente");
          },
        },
      ],
    };

    return (
      <>
        <div style={{ display: "none" }}>
          <FormFw name="form" getParentApi={pageApi.getApi} config={form} />
        </div>
        <FormFw
          name="form3"
          getParentApi={pageApi.getApi}
          config={formConfig3}
        />
        <GridFw
          name="gridObservaciones"
          getParentApi={pageApi.getApi}
          config={gridObservaciones}
        />
        <GridFw
          name="grid12"
          getParentApi={pageApi.getApi}
          config={gridConfig12}
        />
        <BarButtonFw
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonFooterdatos_servicio}
        />
      </>
    );
  }
}
export default OtrosDatosModal;
